var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailfailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 70,
    viewBox: "0 0 81 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 37.588L1.5 15.805V61.588C1.50007 63.179 2.13207 64.7049 3.257 65.83L40.5 43.085L31.5 37.588Z",
    fill: "#AA021D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 15.805L49.5 37.588L40.5 43.084L3.25699 65.83C3.81413 66.3873 4.4756 66.8294 5.20362 67.131C5.93164 67.4327 6.71195 67.588 7.49999 67.588H73.5C75.0913 67.588 76.6174 66.9559 77.7426 65.8306C78.8678 64.7054 79.5 63.1793 79.5 61.588V15.805Z",
    fill: "#FF002A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.805L31.5 37.588L40.5 43.084M40.5 43.084L49.5 37.588L79.5 15.805M40.5 43.084L3.257 65.829M3.257 65.829C2.13207 64.7039 1.50007 63.178 1.5 61.587V15.804C1.50009 15.1624 1.70583 14.5378 2.08703 14.0218C2.46823 13.5058 3.00481 13.1256 3.618 12.937L37.854 2.39999C39.5778 1.86867 41.4216 1.86763 43.146 2.39699L77.382 12.936C77.9954 13.1246 78.532 13.505 78.9133 14.0212C79.2945 14.5374 79.5001 15.1623 79.5 15.804V61.588C79.5 63.1793 78.8679 64.7054 77.7426 65.8306C76.6174 66.9558 75.0913 67.588 73.5 67.588H7.5C6.71196 67.5879 5.93165 67.4327 5.20363 67.131C4.47561 66.8294 3.81414 66.3863 3.257 65.829Z",
    stroke: "#D2D2D2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0018 18.3343V22.9177M52.002 22.001C52.002 23.4457 51.7175 24.8762 51.1646 26.2109C50.6118 27.5456 49.8014 28.7584 48.7799 29.7799C47.7584 30.8014 46.5456 31.6118 45.2109 32.1646C43.8762 32.7175 42.4457 33.002 41.001 33.002C39.5563 33.002 38.1258 32.7175 36.7911 32.1646C35.4564 31.6118 34.2437 30.8014 33.2221 29.7799C32.2006 28.7584 31.3903 27.5456 30.8374 26.2109C30.2845 24.8762 30 23.4457 30 22.001C30 19.0834 31.159 16.2852 33.2221 14.2221C35.2852 12.159 38.0834 11 41.001 11C43.9187 11 46.7168 12.159 48.7799 14.2221C50.843 16.2852 52.002 19.0834 52.002 22.001ZM41.0018 26.5844H41.0116V26.5942H41.0018V26.5844Z",
    stroke: "#FF002B",
    strokeWidth: 1.83337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 70,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailfailed);
export default __webpack_public_path__ + "static/media/emailfailed.80cc4905f18c379819b9bd81bcbeceb6.svg";
export { ForwardRef as ReactComponent };